/**
 * Compute react-query's next page param for a transport infinite query.
 * A null page means the request was not ready, so it has no successor.
 */
export function resolveTransportNextPageParam<TPage, TParam>(
  lastPage: TPage,
  allPages: TPage[],
  lastPageParam: TParam | undefined,
  getNextRequest: (
    lastPage: TPage,
    allPages: TPage[],
    lastPageParam: TParam | undefined,
  ) => TParam | null | undefined,
): TParam | undefined {
  if (lastPage == null) {
    return undefined
  }
  return getNextRequest(lastPage, allPages, lastPageParam) ?? undefined
}
